<template>
  <div class="main main--login">
    <div class="container login">

      <img src="../../assets/img/logo.png" alt="geberit" class="login__logo">
      <form method="post" class="form" v-bind:class="{ pending: pending }" @submit="submit">
        <div class="alert" v-bind:class="{ ['alert-' + message.type]: message.data }" role="alert" v-if="message.data">
          {{ message.data }}
        </div>
        <div class="form__input-container">
          <input type="text" name="email" v-model="form.email" class="form__input" placeholder="Twój adres e-mail">
        </div>
        <div class="form__input-container">
          <button type="submit" class="button button--blue form__submit" v-bind:disabled="pending">Wyślij
            &raquo;</button>
        </div>
      </form>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import AuthenticationService from '@/app/authentication/authentication.service'

export default {
  name: 'ForgetPassword',
  data() {
    return {
      message: {
        type: 'success',
        data: null
      },
      pending: false,
      form: {
        email: ''
      }
    }
  },
  methods: {
    /**
     * Login method.
     *
     * @return {void}
     */
    submit: function (e) {
      e.preventDefault()

      let vm = this
      vm.message.data = null
      vm.pending = true

      Vue.axios({
        method: 'post',
        url: '/password/email',
        data: {
          email: vm.form.email
        }
      })
        .then(response => {
          vm.pending = false
          vm.message.type = 'success'
          vm.message.data = response.data.message

          vm.form.email = null
          e.target.reset()
        })
        .catch(error => {
          vm.pending = false
          vm.message.type = 'danger'
          vm.message.data = error.response.data.message
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/authentication/ForgetPassword.vue